import NotFound from './NotFound';

export default {
  path: '*',
  components: { content: NotFound }
};
